import { CustomCellActionsComponent } from '@app/components/shared/grids/custom-cell-actions/custom-cell-actions.component';
import { CustomCellCompanyComponent } from '@app/components/shared/grids/custom-cell-company/custom-cell-company.component';
import { TabNames } from '@enums/TabNames';
import { ColDef, ICellRendererParams, ValueFormatterParams } from 'ag-grid-enterprise';

export const BUILDING_CONTACTS_GRID_COLUMNS: ColDef[] = [
    {
        colId: 'contactId',
        field: 'contactId',
        headerName: 'ID',
        width: 100,
        lockPinned: true,
        lockPosition: 'left',
        suppressSizeToFit: true,
        cellRenderer: (params: ICellRendererParams) => {
            if (params.value) {
                const link = `/contacts-single/${params.value}/${TabNames[TabNames.Overview]}`;
                return `<a class="anchor" href="${link}">${params.value}</a>`;
            }
            return '';
        }
    },
    {
        colId: 'contactFullName',
        field: 'contactFullName',
        headerName: 'Name',
        cellDataType: 'text'
    },
    {
        colId: 'phone',
        field: 'phone',
        headerName: 'Phone',
        cellDataType: 'text',
        sortable: false,
        valueFormatter: (params: ValueFormatterParams) => {
            if (Array.isArray(params.value)) {
                return params.value.join(', ');
            }
            return params.value || '';
        }
    },
    {
        colId: 'email',
        field: 'email',
        headerName: 'Email',
        cellDataType: 'text',
        sortable: false,
        valueFormatter: (params: ValueFormatterParams) => {
            if (Array.isArray(params.value)) {
                return params.value.join(', ');
            }
            return params.value || '';
        }
    },
    {
        colId: 'buildingContactRoleName',
        field: 'buildingContactRoleName',
        headerName: 'Contact Role',
        cellDataType: 'text'
    },
    {
        colId: 'companyName',
        field: 'companyName',
        headerName: 'Company',
        cellDataType: 'text',
        cellRenderer: CustomCellCompanyComponent
    },
    {
        colId: 'actions',
        headerName: '',
        maxWidth: 80,
        sortable: false,
        filter: false,
        resizable: false,
        suppressHeaderMenuButton: true,
        suppressSizeToFit: true,
        cellRenderer: CustomCellActionsComponent,
        cellClass: 'action-cell'
    }
];
